// @core/api/endpoints/product/remove_product_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/product';

/**
 * Remove product from category
 * Removes a product from a specific category.
 */
export async function RemoveProductCategory(
  product_id: string,
  category_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/categories/:category_id`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
